<div class="spinner-container" *ngIf="visible$ | async" @fadeOut>
    <mat-progress-spinner mode="indeterminate" color="grey"></mat-progress-spinner>
</div>